// extracted by mini-css-extract-plugin
export default {"form":"WalletInputStep_form__pai6U","infoSection":"WalletInputStep_infoSection__PJf7d","infoHeader":"WalletInputStep_infoHeader__ZOzjG"};